import React from 'react';

const Avatar = ({ className, src, alt, size, text }) => {
  const displayText = text ? text.charAt(0).toUpperCase() : '';
  return (
    <div
      className={className}
    >
      {src ? (
        <img
          src={src}
          alt={alt}
        />
      ) : (
        <span>{displayText}</span>
      )}
    </div>
  );
};

export default Avatar;
